import React, {FC} from 'react';
import {useNavigate} from 'react-router';
import {createCurrencyFormatter} from '~/entities/currencies';
import {RsnPicker} from '~/library/ui-kit';
import {BareAccount} from "../../model/Scheme/BareAccount";

interface AccountWidgetProps {
    readonly modalTitle: string;

    readonly account: BareAccount;

    readonly accounts: BareAccount[];

    readonly buildPath: (account: BareAccount) => string;
}

/**
 * @deprecated - use SelectAccount
 */
const AccountWidget: FC<AccountWidgetProps> = ({modalTitle, account, accounts, buildPath}) => {
    const navigate = useNavigate();

    const accountsOptions: RsnPicker.OptionObject<BareAccount>[] = accounts.map(account => {
        const {format} = createCurrencyFormatter({code: account.currency, decimals: account.decimals});
        return {
            value: account,
            title: account.title,
            icon: {src: account.icon},
            hint: `Balance: ${format(account.balance)}`,
        };
    });

    const handleChange = (account: BareAccount) => {
        navigate(buildPath(account), {replace: true});
    };

    return (
        <RsnPicker title={modalTitle} onChange={handleChange} keyedBy='id' options={accountsOptions} value={account} />
    );
};

export default AccountWidget;
